// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";

import Navbar from "./components/Navbar";
// import ComplianceBanner from "./components/ComplianceBanner"; // rimosso: footer strutturato è sufficiente
import Footer from "./components/Footer";
import CookieConsentBanner from "./components/CookieConsentBanner";

import HomePage from "./pages/HomePage";
import SolutionsPage from "./pages/SolutionsPage";
import ToolsPage from "./pages/ToolsPage";
import AboutPage from "./pages/AboutPage";
import KnowledgeBase from "./pages/KnowledgeBase";
import ArticlePage from "./pages/ArticlePage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import TransparencyPage from "./pages/TransparencyPage";
import OcfHub from "./pages/OcfHub";
import OcfEpisode from "./pages/OcfEpisode";
import SeriesHub from "./pages/SeriesHub";
import LabHub from "./pages/LabHub";
import LabEpisode from "./pages/LabEpisode";
import DerivatiHub from "./pages/DerivatiHub";
// LabTrack: in STANDBY (rotta disattivata; pagina pronta, in attesa di validazione legale).
// import LabTrack from "./pages/LabTrack";

import { LangProvider } from "./lang/LangProvider";
import { useAnalytics } from "./hooks/useAnalytics";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Invia un page_view a ogni cambio rotta: in index.html send_page_view è false,
// quindi in questa SPA i page_view vanno emessi manualmente, altrimenti GA4
// registra una sola vista per sessione e il funnel resta cieco in testa.
function PageViewTracker() {
  const { pathname, search } = useLocation();
  const { trackPageView } = useAnalytics();
  React.useEffect(() => {
    const lang = pathname.split("/")[1] || "it";
    // Differito: lascia che l'effetto di <Seo> aggiorni document.title prima
    // che leggiamo il page_title (Seo è renderizzato dopo questo tracker).
    const id = setTimeout(() => trackPageView(pathname + search, lang), 0);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, search]);
  return null;
}

function AppShell() {
  return (
    <>
      <Navbar />
      {/* <ComplianceBanner /> — rimosso: il footer strutturato è sufficiente */}
      <main id="main">
        <Routes>
          <Route path="" element={<HomePage />} />
          <Route path="solutions" element={<SolutionsPage />} />
          <Route path="tools" element={<ToolsPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="kb" element={<KnowledgeBase />} />
          <Route path="kb/:slug" element={<ArticlePage />} />
          <Route path="ocf" element={<OcfHub />} />
          <Route path="ocf/:materia/:slug" element={<OcfEpisode />} />
          <Route path="series" element={<SeriesHub />} />
          <Route path="series/lab" element={<LabHub />} />
          <Route path="series/derivati" element={<DerivatiHub />} />
          {/* series/lab/track in STANDBY: nessuna rotta → /series/lab/track cade su :slug e reindirizza all'hub */}
          <Route path="series/lab/:slug" element={<LabEpisode />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="transparency" element={<TransparencyPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

// Redirect iniziale: / -> /it oppure /en (solo prima visita)
function LangAutoRedirect() {
  React.useEffect(() => {
    const saved = localStorage.getItem("lang");
    const browser = (navigator.language || "it").toLowerCase();
    const guess = saved || (browser.startsWith("en") ? "en" : "it");
    // evitiamo loop: sostituiamo la history
    window.location.replace(`/${guess}`);
  }, []);
  return null;
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <PageViewTracker />
      <CookieConsentBanner />
      <Routes>
        <Route path="/" element={<LangAutoRedirect />} />
        <Route
          path="/:lang/*"
          element={
            <LangProvider>
              <AppShell />
            </LangProvider>
          }
        />
        <Route path="*" element={<Navigate to="/it" replace />} />
      </Routes>
    </Router>
  );
}
